import script from "./OnboardingAiResearchReviewStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiResearchReviewStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiResearchReviewStep.vue?vue&type=style&index=0&id=236151e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236151e8"]])

export default __exports__